var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGuideline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.49609C26.7843 2.49609 33.5 9.21181 33.5 17.4961C33.5 25.5654 27.1286 32.1449 19.142 32.4811C19.1374 32.4813 19.1339 32.485 19.1343 32.4896C19.1347 32.4942 19.131 32.498 19.1263 32.498H5.64286C4.45939 32.498 3.5 31.5387 3.5 30.3552V16.8703C3.5 16.8664 3.50312 16.8633 3.50698 16.8633C3.51072 16.8633 3.5138 16.8603 3.51395 16.8566C3.84905 8.869 10.4301 2.49621 18.5 2.49609Z",
    fill: "#FF7471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGuideline);
export default __webpack_public_path__ + "static/media/Ico_Guideline.d0bccb4edc18da02e28a8855e0e53bc6.svg";
export { ForwardRef as ReactComponent };